import { Metadata, TrackAction } from './types'

type TrackMenu = TrackAction<{ (metadata: Metadata): void }>

const EVENT_CATEGORY = 'menu'
const MENU_OPENED = 'menu_opened'
const MENU_CLOSED = 'menu_closed'

export const trackMenuOpen: TrackMenu = (track) => (metadata) => {
  void track(MENU_OPENED, {
    ...metadata,
    category: EVENT_CATEGORY,
    label: metadata.name,
  })
}

export const trackMenuClose: TrackMenu = (track) => (metadata) => {
  void track(MENU_CLOSED, {
    ...metadata,
    category: EVENT_CATEGORY,
    label: metadata.name,
  })
}
